import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from '../../util/reactIntl';
import { shouldShowGuideReminder, snoozedGuideState } from '../../util/photographerGuide';
import { updateProfile } from '../../containers/ProfileSettingsPage/ProfileSettingsPage.duck';
import NamedLink from '../NamedLink/NamedLink';

import css from './GuideReminder.module.css';

// Shown to photographers who have neither confirmed the guide nor skipped it recently.
// "Skip for now" hides it for a week (see util/photographerGuide.js).
const GuideReminder = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(state => state.user.currentUser);

  if (!shouldShowGuideReminder(currentUser)) {
    return null;
  }

  const onSkip = () =>
    dispatch(updateProfile({ privateData: { photographerGuide: snoozedGuideState(currentUser) } }));

  return (
    <div className={css.root} role="note">
      <div className={css.text}>
        <strong className={css.title}>
          <FormattedMessage id="GuideReminder.title" />
        </strong>
        <span>
          <FormattedMessage id="GuideReminder.text" />
        </span>
      </div>
      <div className={css.actions}>
        <NamedLink name="PhotographerGuidePage" className={css.readButton}>
          <FormattedMessage id="GuideReminder.read" />
        </NamedLink>
        <button type="button" className={css.skipButton} onClick={onSkip}>
          <FormattedMessage id="GuideReminder.skip" />
        </button>
      </div>
    </div>
  );
};

export default GuideReminder;
